module.exports = __webpack_public_path__ + "assets/img/main-logo_mobile-xingtai.b19569bb.png";